//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { mapGetters } from 'vuex'

import DateTimeField from '../../components/Field/DateTimeField.vue'

export default {
  components: {
    DateTimeField

  },
  props: {
    value: {
      type: Object,
      default: null
    },
    date: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      brigades: [],
      workShift: null,
      workDate: null,

      loading: false,
      initialized: false
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts'
    }),
    workShifts: function () {
      return this.getWorkShifts.filter(ws => ws.active)
    }
  },
  watch: {
    workShift: function (brigade) {
      if (brigade && this.initialized) {
        this.getBrigades()
      } else {
        this.selectedBrigades = []
      }
    },
    workDate: function (brigade) {
      if (brigade && this.initialized) {
        this.getBrigades()
      }
      this.selectedBrigades = []
    }
  },
  created: function () {
    this.setDefaultParameters()
    this.getBrigades()
    this.$nextTick(() => {
      this.initialized = true
    })
  },
  methods: {
    isSelectedBrigade: function (brigade) {
      return this.value && this.value.id === brigade.id && this.value.workShift.key === this.workShift.key && this.value.workDate === this.workDate
    },
    setDefaultParameters: function () {
      let date = null
      if (this.date) {
        date = new Date(this.date)
      } else {
        date = new Date()
      }

      const user = this.$store.getters.getUser
      let limitHoursToDisplayNightWorkShift = 0
      if (user.employee && user.employee.workAreas.includes('СО')) {
        limitHoursToDisplayNightWorkShift = 7
      }

      if (date.getHours() < limitHoursToDisplayNightWorkShift) {
        date.setDate(date.getDate() - 1)
        this.workShift = this.workShifts.find(workShift => workShift.key === 'brigadier.20-32')
      } else {
        if (date.getHours() < 8) {
          this.workShift = this.workShifts.find(workShift => workShift.key === 'brigadier.7-19')
        } else if (date.getHours() < 20) {
          this.workShift = this.workShifts.find(workShift => workShift.key === 'brigadier.8-20')
        } else {
          this.workShift = this.workShifts.find(workShift => workShift.key === 'brigadier.20-32')
        }
      }

      date.setHours(0, 0, 0, 0)
      this.workDate = date.getTime()
    },
    setBrigadeProperties: function (brigade) {
      if (brigade) {
        this.value.id = brigade.id
        this.value.name = brigade.guiName || brigade.name
        this.value.workAreas = brigade.workAreas
        this.value.workShift = this.workShift
        this.value.workDate = this.workDate
      } else {
        this.value.id = null
        this.value.name = null
        this.value.workAreas = []
        this.value.workShift = null
        this.value.workDate = null
      }
    },
    onSelectBrigadeExact: function (brigade) {
      this.setBrigadeProperties(brigade)
    },
    getBrigades: function () {
      this.loading = true
      this.brigades = []

      const params = new URLSearchParams()
      params.set('state', 'valid')
      params.set('sort', 'name')
      params.set('dir', 'ASC')

      params.set('workDate', this.workDate)
      params.set('workShift', this.workShift.key)
      params.set('fields', 'guiName,workShift,workAreas')

      return axiosGet({
        url: '/service/delta/brigade/lightsearch?' + params.toString(),
        onSuccess: (response) => {
          this.brigades = response.data
        },
        onFailure: 'Ошибка загрузки бригад'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

